import React from 'react';
import { Container, ContentContainer, InfoText } from './styles';
import { IoShapesOutline } from 'react-icons/io5';

interface IEmptyData {
  icon?: () => JSX.Element;
  noPadding?: boolean;
  small?: boolean;
  redColor?: boolean;
}

export const EmptyData: React.FC<IEmptyData> = (props) => {
  const { children, icon: Icon, noPadding, small, redColor } = { ...props };
  return (
    <ContentContainer noPadding={noPadding}>
      <Container redColor={redColor}>
        {!!Icon ? <Icon /> : <IoShapesOutline />}
        <InfoText redColor={redColor} small={small}>
          {children}
        </InfoText>
      </Container>
    </ContentContainer>
  );
};
